import { useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';
import { NavigateFunction } from 'react-router-dom';

import { TLocalesKeys } from 'localization';
import {
  DELETE_WORKER,
  IDeleteWorkerRequest,
  IDeleteWorkerResponse,
} from 'schemas';
import notification from 'services/notificationService';

import { IDeleteWorker } from './interfaces';

export const useDeleteWorker = (
  t: TTranslator<TLocalesKeys>,
  navigate: NavigateFunction
): IDeleteWorker => {
  const [deleteWorker, { loading }] = useMutation<
    IDeleteWorkerResponse,
    IDeleteWorkerRequest
  >(DELETE_WORKER, {
    onCompleted: () => {
      navigate('/workers', { replace: true });
      notification.info({
        t,
        title: t('worker.deleted'),
        type: 'warning',
        dismiss: 5,
      });
    },
    onError: console.error,
    fetchPolicy: 'no-cache',
  });

  return { deleteWorker, loading };
};
